// extracted by mini-css-extract-plugin
export default {"section":"StandingOrders_section__Jtdsr api-enabler-styles_overviewSection__Dxvs2"};